import React from "react";

export default function VehicleAfterSaleServices({ data, loading, children }) {
  return <div>{children}</div>;
}
